import { js_utils } from "../utils/frfr-js-utils";
import { lib_ter_materijal_lim_cache_get, ter_sifrarnik_jedinice_cache_get } from "./ter-cache-utils";
// import { terLibSifrarnikJedinice } from "./ter-params-lib";
// import { terLibMaterijalLim } from "./ter-params-materijal-lim-lib";
// import { terLibParametriMaterijaliPrvi, terLibSifrarnikJedinice, terLibSifrarnikOp, terLibSifrarnikRadniCentri } from "./ter-params-lib"; // parametri iz biblioteke


//
export const _getParamsFromLibMaterijalLimParams = (lib_entity_key) => {
  let params = {};
  const terLibSifrarnikJedinice = ter_sifrarnik_jedinice_cache_get(); // koristimo keširane podatke
  const terLibMaterijalLim = lib_ter_materijal_lim_cache_get(); // koristimo keširane podatke
  if (js_utils.is_object(terLibMaterijalLim[lib_entity_key])) {
    params = {
      ...terLibMaterijalLim[lib_entity_key]
    };
    if (params["jm"]) {
      // u slucaju da se trazi parametar koji kao value ima KEY za SPISAK sa kojeg se uzima
      params["jm"] = terLibSifrarnikJedinice[params["jm"]];
    } /* else if (params["operacija"]) {
      // u slucaju da se trazi parametar koji kao value ima KEY za SPISAK sa kojeg se uzima
      params["operacija"] = terLibSifrarnikOp[params["operacija"]];
    } else if (params["rc"]) {
      // u slucaju da se trazi parametar koji kao value ima KEY za SPISAK sa kojeg se uzima
      params["rc"] = terLibSifrarnikRadniCentri[params["rc"]];
    } */
  }
  // console.log('params', params);
  return params;
};


//
export const _getFromLibMaterijalLimSingleParam = (lib_entity_key, param_key) => {
  const terLibSifrarnikJedinice = ter_sifrarnik_jedinice_cache_get(); // koristimo keširane podatke
  const lib_entity = _getParamsFromLibMaterijalLimParams(lib_entity_key);
  // console.log('+++++++ lib_entity', lib_entity);
  // if (js_utils.is_object(terLibMaterijalLim[lib_entity_key])) {
  if (js_utils.is_object(lib_entity)) {
    // let param_val = terLibMaterijalLim[lib_entity_key][param_key];
    let param_val = lib_entity[param_key];
    if (param_key === "jm") {
      // u slucaju da se trazi parametar koji kao value ima KEY za SPISAK sa kojeg se uzima
      return terLibSifrarnikJedinice[param_val];
    } /* else if (param_key === "operacija") {
      // u slucaju da se trazi parametar koji kao value ima KEY za SPISAK sa kojeg se uzima
      return terLibSifrarnikOp[param_val];
    } else if (param_key === "rc") {
      // u slucaju da se trazi parametar koji kao value ima KEY za SPISAK sa kojeg se uzima
      return terLibSifrarnikRadniCentri[param_val];
    } */
    return param_val;
  }
};

